<div class="articoloContainer" *ngIf="Articolo">
  <div class="row d-flex justify-content-end">
    <div class="col-md-3" *ngFor="let item of Articolo?.pareri">
      <div class="boxParere">
        <div class="d-flex justify-content-between align-items-center">
          <marquee
            loop="-1"
            [scrollAmount]="item?.Label?.toString()?.length > 14 ? 5 : 0"
            scrolldelay="10"
            direction="left"
            align="right" width="50%" class="text-white " style="font-family: TitilliumWeb-SemiBold; font-size: 1.5rem">{{item.Label}}</marquee>
          <button *ngIf="item.Value != 0" class="btn" [style.background-color]="getCOLORParere(item.Value)" style="font-weight: bold">{{getlabelrel(item.Value)}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between" style="padding-top: 0; padding-left: 1em; padding-right: 0;">
    <div class="d-flex align-items-end justify-content-start">
      <span  class="text-white" style="font-family: TitilliumWeb-Bold; font-size: 2.5em">{{Articolo.commissione}}</span>
    </div>
    <div class="d-flex align-items-center justify-content-end" >
      <button class="btn rounded-button" *ngIf="Articolo.parteAmmissibile" style="margin-right: 1em; " [style.color]="Articolo.parteAmmissibile? '#000000': '#cbcccb'" [style.background-color]="Articolo.parteAmmissibile? '#F3E600': 'transparent'">PARTE AMMISSIBILE</button>
      <button class="btn rounded-button" *ngIf="Articolo?.riform != '' "  [style.background-color]="'rgba(198,198,198,0.7)'">Riform. {{Articolo?.riform.split('.')[1] | number: '2.0-0'}}</button>
    </div>
  </div>
  <div class="d-flex justify-content-between" style=" padding-left: 1em; padding-right: 1em;">
    <div class="d-flex align-items-start justify-content-start" style="">
      <span class="text-white" style="font-family: TitilliumWeb-Bold; font-size: 2.5em">{{Articolo.titolo}}</span>
    </div>
    <div class="d-flex align-items-end justify-content-end" style="margin-top: 1rem;">
      <span class="text-white" style="font-family: TitilliumWeb-SemiBold; font-size: 2em">pagina fascicolo n.{{Articolo.fascicolo}}</span>
    </div>
  </div>
  <hr class="hr">
  <div class="row ">
    <div class="col-3">

    </div>
    <div class="col-6 " style="padding: 0.5em; margin-top: 0">
      <div class="row">
        <div class="col-4 trdButtonsDiv">
          <button class="btn trdButtons" [disabled]="Articolo.disabled" (click)="decisione('accantonato')"  [style.border-color]="YELLOW"  [style.background-color]="Articolo.accantonato? YELLOW: 'rgba(39,39,38,0.8)'">ACCANTONATO</button>
        </div>
        <div class="col-4 trdButtonsDiv">
          <button class="btn trdButtons" [disabled]="Articolo.disabled" (click)="decisione('stato', 2)"  [style.border-color]="RED"  [style.background-color]="Articolo.stato == 2? RED: 'rgba(39,39,38,0.8)'">RITIRATO</button>
        </div>
        <div class="col-4 trdButtonsDiv">
          <button class="btn trdButtons" [disabled]="Articolo.disabled" (click)="decisione('stato', 3)"  [style.border-color]="RED"  [style.background-color]="Articolo.stato == 3? RED: 'rgba(39,39,38,0.8)'">DECADUTO</button>
        </div>
        <div class="col-6 secButtonsDiv">
          <button class="btn secButtons" [disabled]="Articolo.disabled" (click)="decisione('esito', 2)"  [style.border-color]="YELLOW"  [style.background-color]="Articolo.parere == 2? YELLOW: 'rgba(39,39,38,0.8)'">ASS</button>
        </div>
        <div class="col-6 secButtonsDiv">
          <button class="btn secButtons" [disabled]="Articolo.disabled" (click)="decisione('esito', 3)"  [style.border-color]="CYAN"  [style.background-color]="Articolo.parere == 3? CYAN: 'rgba(39,39,38,0.8)'">PRE</button>
        </div>
        <div class="col-6 mainButtonsDiv">
          <button class="btn mainButtons" [disabled]="Articolo.disabled" (click)="decisione('esito', 1)"  [style.border-color]="GREEN"  [style.background-color]="Articolo.parere == 1? GREEN: 'rgba(39,39,38,0.8)'">APP</button>
        </div>
        <div class="col-6 mainButtonsDiv">
          <button class="btn mainButtons" [disabled]="Articolo.disabled" (click)="decisione('esito', 4)" [style.border-color]="RED"  [style.background-color]="Articolo.parere == 4? RED: 'rgba(39,39,38,0.8)'">RES</button>
        </div>
      </div>
    </div>
    <div class=" col-3 d-flex align-items-end justify-content-center" >
      <span  style="font-family: TitilliumWeb-Bold; margin-bottom: 0em; font-size: 45pt" [style.color]="getColorStato(Articolo)" >{{stato}}</span>
    </div>
  </div>
<!--  <hr class="bottomHr">-->
<!--  <div class="d-flex justify-content-center">-->
<!--    <button class="btn" (click)="openPopup()" style="background-color: transparent"><img style="background-color: transparent" src="assets/images/icon/frecciasu.png"/></button>-->
<!--  </div>-->
</div>
